import FunctionalButton from "./FunctionalButton";

const SubmitButton = ({
    className,
    ...otherProps
}: React.ComponentProps<typeof FunctionalButton>) => (
    <FunctionalButton {...otherProps} className="button min-w-fit"></FunctionalButton>
);

export default SubmitButton;
